import React, { useMemo, useState } from 'react'
import { withRouter } from 'react-router-dom'

import { useSelector, useDispatch } from 'react-redux'

import { ButtonGroup, Button } from '@material-ui/core'
import Tooltip from '@material-ui/core/Tooltip'

import Settings from '@material-ui/icons/Settings'
import Tune from '@material-ui/icons/Tune'
import PhotoCameraIcon from '@material-ui/icons/PhotoCamera'
import Reports from '@material-ui/icons/Assignment'
import Assessment from '@material-ui/icons/Assessment'

import { formatStatusClass, getViolationIndex } from '../../../utils'

import { setAllChecked, setStatusSnack, setSelectedReport, setPageType } from '../../../redux/actions/select'

import queryString from 'query-string'

const NavButtonContainer = (props) => {
  const dispatch = useDispatch()

  const { toggleSettingsModal, toggleFilterModal } = { ...props }

  const DefaultView = useSelector(state => state.userSettings.general.defaultView)
  const Captures = useSelector(state => state.violations.violations.captures)
  const PageCaptureLimit = useSelector(state => state.selection.PageCaptureLimit)

  const [parsedProps, setParsedProps] = useState({ view: '', page: 0, captureTrgts: null })

  useMemo(() => {
    if (props.location && Boolean(props.location.search) && typeof PageCaptureLimit === 'number') {
      try {
        const searchProps = queryString.parse(props.location.search)

        if (searchProps && typeof searchProps === 'object' && Boolean(searchProps.view)) {
          // !!TO DO: This logic is duplicated numerous times in various files. Need to move to util or move this memo to a parent component of all files in which it is used.
          const captureTrgts = (() => {
            switch (searchProps.view) {
              case 'single': {
                try {
                  // capture (singular) returns a number string, with a 1 based index
                  return parseInt(searchProps.capture) || null
                } catch (err) {
                  return null
                }
              }
              case 'grid': {
                try {
                  // active captures (plural) in grid view returns an array (considered truthy even when empty so the following logic will work as expected)
                  return JSON.parse(searchProps.activeCaptures) || null
                } catch (err) {
                  return null
                }
              }
              case 'list': {
                try {
                  // active capture (singular) in list view returns a number string, with a 0 based index.
                  // Previously this used the same logic as the 'single' case. However as it was 0 based, the `parseInt(searchProps.activeCapture) || null` always returned null at the first index as 0 is falsey
                  const parsedCaptureNum = parseInt(searchProps.activeCapture)
                  if (!isNaN(parsedCaptureNum)) {
                    return parsedCaptureNum
                  } else {
                    return null
                  }
                } catch (err) {
                  return null
                }
              }
              default: return null
            }
          })()

          const page = (() => {
            if (searchProps.view === 'single' && typeof captureTrgts === 'number') { return Math.floor((captureTrgts - 1) / PageCaptureLimit) + 1 }
            return parseInt(searchProps.page) || 0
          })()

          setParsedProps({ view: searchProps.view, page, captureTrgts })
        }
      } catch (err) {
        console.log(err)
      }
    }
  }, [props.location, PageCaptureLimit])

  const setDashboard = async () => {
    if (parsedProps.view === 'dashboard' || parsedProps.view !== 'single') {
      dispatch(setAllChecked(false))
      props.history.push('/dashboard')
    } else {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
      if (typeof captureIx === 'number' && Captures[captureIx] && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('dashboard'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        props.history.push('/dashboard')
      }
    }
  }

  const setReports = async () => {
    if (parsedProps.view === 'dashboard' || parsedProps.view !== 'single') {
      dispatch(setAllChecked(false))
      dispatch(setSelectedReport('users'))
      props.history.push('/reports')
    } else {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
      if (typeof captureIx === 'number' && Captures[captureIx] && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('reports'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        dispatch(setSelectedReport('users'))
        props.history.push('/reports')
      }
    }
  }

  const setCaptures = async () => {
    if (parsedProps.view === 'dashboard' || parsedProps.view !== 'single') {
      dispatch(setAllChecked(false))
      if (DefaultView === 'L') {
        props.history.push({
          pathname: '/captures',
          search: '?view=list&page=1&activeCapture=0'
        })
      } else if (DefaultView === 'G') {
        props.history.push({
          pathname: '/captures',
          search: '?view=grid&page=1&activeCaptures=[]'
        })
      } else if (DefaultView === 'D') {
        props.history.push({
          pathname: '/captures',
          search: '?view=single&capture=1'
        })
      }
    } else {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
      if (typeof captureIx === 'number' && Captures[captureIx] && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('captures'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        if (DefaultView === 'L') {
          props.history.push({
            pathname: '/captures',
            search: '?view=list&page=1&activeCapture=0'
          })
        } else if (DefaultView === 'G') {
          props.history.push({
            pathname: '/captures',
            search: '?view=grid&page=1&activeCaptures=[]'
          })
        } else if (DefaultView === 'D') {
          props.history.push({
            pathname: '/captures',
            search: '?view=single&capture=1'
          })
        }
      }
    }
  }

  const handleFilterModal = () => {
    if (parsedProps.view === 'dashboard' || parsedProps.view !== 'single') {
      toggleFilterModal()
    } else {
      const captureIx = getViolationIndex({ captureNum: parsedProps.captureTrgts, pageLimit: PageCaptureLimit, page: parsedProps.page, currentView: parsedProps.view })
      if (typeof captureIx === 'number' && Captures[captureIx] && formatStatusClass(Captures[captureIx].statusFlag, 'text') === 'New') {
        dispatch(setStatusSnack(true))
        dispatch(setPageType('advanced-filter'))
      } else {
        dispatch(setStatusSnack(false))
        dispatch(setPageType(null))
        toggleFilterModal()
      }
    }
  }

  return (
    <div className='settings-button'>
      <ButtonGroup orientation='vertical' variant='text' id='settings-filter-group'>
        <Tooltip title='Dashboard' placement='left' arrow>
          <Button
            className='toggleButton view-buttons text-white' onClick={(e) => { e.preventDefault(); setDashboard() }}
          >
            <Assessment className='bigIcon' />
          </Button>
        </Tooltip>
        <Tooltip title='Captures' placement='left' arrow>
          <Button
            className='toggleButton view-buttons text-white' onClick={(e) => { e.preventDefault(); setCaptures() }}
          >
            <PhotoCameraIcon className='bigIcon' />
          </Button>
        </Tooltip>
        <Tooltip title='Reports' placement='left' arrow>
          <Button
            className='toggleButton view-buttons text-white' onClick={(e) => { e.preventDefault(); setReports() }}
          >
            <Reports className='bigIcon' />
          </Button>
        </Tooltip>
        <Tooltip title='Advanced Filters' placement='left' arrow>
          <Button
            className='toggleButton view-buttons text-white'
            onClick={(e) => { e.preventDefault(); handleFilterModal() }}
          >
            <Tune className='bigIcon' />
          </Button>
        </Tooltip>
        <Tooltip title='Settings' placement='left' arrow>
          <Button
            className='toggleButton view-buttons text-white' onClick={toggleSettingsModal}
          >
            <Settings className='bigIcon' />
          </Button>
        </Tooltip>
      </ButtonGroup>
    </div>
  )
}

export default withRouter(NavButtonContainer)
